"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.532 4.4c-.604.01-1.345.443-1.505 1.625-.107.8-.294 1.938-.519 3.287h2.607a.7.7 0 0 1 0 1.4h-2.84l-.038.226c-.343 2.066-.732 4.46-1.064 6.876-.146 1.06-.526 1.872-1.084 2.419a2.62 2.62 0 0 1-1.945.765C5.82 20.95 4.55 19.89 4.55 18.336a.7.7 0 0 1 1.4 0c0 .713.583 1.24 1.245 1.263.31.012.635-.093.914-.366.283-.278.562-.774.677-1.61a252 252 0 0 1 1.07-6.911H7.103a.7.7 0 1 1 0-1.4h2.985c.241-1.45.44-2.65.55-3.474.247-1.826 1.533-2.816 2.87-2.838 1.325-.021 2.6.934 2.638 2.627a.7.7 0 1 1-1.4.032c-.02-.864-.599-1.269-1.215-1.259m.082 9.202a.7.7 0 0 1 .99-.01l1.828 1.787 1.828-1.788a.7.7 0 1 1 .98 1.001l-1.807 1.766 1.806 1.767a.7.7 0 0 1-.979 1l-1.828-1.788-1.828 1.788a.7.7 0 0 1-.979-1l1.806-1.767-1.806-1.766a.7.7 0 0 1-.01-.99",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FormulaIcon24.js.map